import getLocale from "../utils/getLocale";

export class OfferRequest {
  public Configuration = new class {
    public Agent = "RADON.WEB";
    public ClientCode!: string;
    public Channel = "Web";
    public ISOCurrency = "CAD";
  }
  public Coverage = new class {
    public PurchaseDate!: string;
    public PricingDate!: string;
    public DepositDate!: string;
    public StartDate!: string;
    public EndDate!: string;
    public ProvinceOfResidence!: string;
    public Insured!: {};

  }

  constructor() {}

  public getOffer(callback: any) {
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4) {
        if(this.status===200){
          callback(this.status, JSON.parse(this.responseText));
        }
        else {
          callback(this.status);
        }
      }
    };
    xhttp.open("POST", "/"+getLocale(true)+"/api/offer", true);
    xhttp.setRequestHeader("Content-type", "application/json");

    xhttp.send(JSON.stringify(this));
  }
}
